import React from "react";
import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Chart} from "react-google-charts";
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import { IAM_API_BASE_URL_2, IAM_API_BASE_URL_3 } from "../../../services/TapApiUrls";
import DateService from "../../../services/DateService";

class AssetWiseSegregation extends AppBaseComponent {

    constructor() {
        super();
        this.state                      =   {
            iam_user_sites              :   [],
            iam_asset_types             :   [],
            complianceForm              :   {period : 'current_month',search_site_ids:[]},
            loading                     :   false,
            data                        :   [],
            remark_day                  :   0,
            remark_time                 :   '',
            not_active                  :   0,
            all_periods                 :   [],
            notes                       :   '',
            notes2                      :   ''
        }
        this.updateMyDashboardRef      =   React.createRef()
    }


    componentDidMount() {
        this.initilaizeFormFilter(this.props);
        if (localStorage.getItem('segregationWidget')) {
            let complianceData = JSON.parse(localStorage.getItem('segregationWidget'));
            if (complianceData) {
                let differenceInSeconds =   DateService.differenceInSeconds(moment(complianceData.time, 'DD-MMM-YYYY HH:mm A').format());
                if (differenceInSeconds > 86400) {
                    localStorage.removeItem('segregationWidget')
                    setTimeout(() => {
                        this.getSegrationListing();
                    }, 1000 * (this.props.indexProps ? this.state.indexProps : 13));
                   
                } else {
                    this.setState({
                        data            :       complianceData.data,
                        remark_time     :       complianceData.time,
                        notes           :       complianceData.notes,
                        notes2          :       complianceData.notes2
                })

                }
            }else{
                setTimeout(() => {
                    this.getSegrationListing();
                }, 1000 * (this.props.indexProps ? this.state.indexProps : 13));
            }
        } else {
            setTimeout(() => {
                this.getSegrationListing();
            }, 1000 * (this.props.indexProps ? this.state.indexProps : 13));
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.iam_user_sites !== this.props.iam_user_sites || nextProps.dashboard_filter_site_id !== this.props.dashboard_filter_site_id || nextProps.clearDashboardFilter !== this.props.clearDashboardFilter) {
            this.initilaizeFormFilter(nextProps);
        }
    }

    initilaizeFormFilter               =   (props)  =>  {
        if(props.all_periods && props.all_periods.length > 0) {
            this.setState({
                all_periods             :   props.all_periods ? props.all_periods.map((s) => { return {value: s.key, label: `${s.display}`}}) : [],
                iam_user_sites           :   props.iam_user_sites ? props.iam_user_sites.map((s) => { return {value: s.id, label: `${s.site_name} (${s.site_code})`}}) : [],
            }, () => {
                if(props.dashboard_filter_site_id || props.clearDashboardFilter == 'yes'){
                   
                    this.setState({
                        complianceForm              :   {
                            search_site_ids         :       props.dashboard_filter_site_id ?  [props.dashboard_filter_site_id] : [],
                            period                  :       "current_month"
                        },
                        
                    },() =>  this.getSegrationListing())
                }
            });
        }
    }

    getSegrationListing                =   (reload=false)  =>  {
        this.setState({loading: true});
        let params          =   {
            action  :   "widget",
            date_range  :   this.state.complianceForm.period,
            search_site_ids : this.state.complianceForm && this.state.complianceForm.search_site_ids && this.state.complianceForm.search_site_ids.length > 0 ? [this.state.complianceForm.search_site_ids] : null ,
            reload : reload ? 'reload' : false};
            
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_3 + '/report/asset-utillisation', this.props.access_token, params, {}, (response) => {
            
            this.setState({
                data            :       [...response.data.data],
                notes           :       response.data.notes,
                notes2          :       response.data.notes2,
                remark_time     :       response.data.time, 
            })
  
            if(this.state.complianceForm.period == "current_month" && this.state.complianceForm.search_site_ids && this.state.complianceForm.search_site_ids.length == 0){
                localStorage.setItem('segregationWidget',JSON.stringify(response.data));
            }
            if(reload !== false){
                localStorage.setItem('segregationWidget',JSON.stringify(response.data));
            }
            
        }).then(() => this.setState({ loading: false }));
    }

    pinMyDashboardHandler = (widgetData=null) => {
        this.updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData,{key:"iam-asset-utilization",name:"Asset Utilisation and Availability"})
    }
  
    render                      =   ()  =>  {
      
        let filterObj           =   {};
         if(this.state.complianceForm){
            if(this.state.complianceForm.period){
                filterObj           =   {...filterObj , 'date_range' : this.state.complianceForm.period}
            }
            if(this.state.complianceForm.search_site_ids && this.state.complianceForm.search_site_ids.length > 0 ){
                filterObj           =   {...filterObj , 'search_site_ids' : this.state.complianceForm.search_site_ids}
            }
     }
     let widgetData = this.props.widget_keys && this.props.widget_keys.length > 0 && this.props.widget_keys.find(st => {return("iam-asset-utilization" == st.key)}) ? this.props.widget_keys.find(st => {return(st.key == "iam-asset-utilization")})  : null;
        return (<div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color">Asset Utilisation and Availability</h6>
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            isClearable={false}
                            placeholder="Select Period"
                            containerHeight="33px"
                            fontSize="93%"
                            options={this.state.all_periods}
                            value={this.state.all_periods.find(r => r.value === this.state.complianceForm.period)}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'complianceForm', 'period', () => this.getSegrationListing())}
                        />
                    </div>
                    <div className="col-3">
                    <TapSelect
                            options={this.state.iam_user_sites}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="All Sites"
                            containerHeight="33px"
                            fontSize="93%"
                            value={this.state.iam_user_sites.find(r =>  this.state.complianceForm.search_site_ids.includes(r.value))}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'complianceForm', 'search_site_ids', () => this.getSegrationListing()) }
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-2 btn btn-light btn-block" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={this.getSegrationListing}>Refresh</li>
                            <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => this.pinMyDashboardHandler(widgetData)}>{!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}</li>
                        </ul>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <table className="table table-hover table-bordered table-borderless bg-white">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th style={{ width: "25%" }} className="text-center" >Percentage</th>
                                    <th className="text-center" style={{ width: "25%" }}>Availability</th>
                                    <th className="text-center" style={{ width: "25%" }}>Utilization Based on Planned Hrs / Km </th>
                                    <th className="text-center" style={{ width: "25%" }}>Utilisation Based on Total Hrs</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading
                                    ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                    : (this.state.data && this.state.data.length > 0
                                        ? (this.state.data.map((w, index) => {
                                            let obj = {'status' : w.key ,'date_range' : this.state.complianceForm.period}
                                            if(this.state.complianceForm && this.state.complianceForm.search_site_ids){
                                                obj['search_site_ids']    =   this.state.complianceForm.search_site_ids
                                            }
                                            return (<tr key={index} className="text-center">
                                                <td className="text-start">{w.name}</td>
                                                <td>{w.availability_count ? w.availability_count : "0"}</td>
                                               <td>{w.utilization_plannedhr_count ? w.utilization_plannedhr_count : "0"}</td>
                                               <td>
                                                 <Link to={{ pathname: "/report/asset_utilization_report", search: "?" + new URLSearchParams(obj).toString() }}>
                                                {w.utilization_totalhr_count ? w.utilization_totalhr_count : "0"}</Link></td>
                                                
                                            </tr>)
                                        }))
                                        : (<tr><td colSpan="4" className="text-center">No Records</td></tr>)
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6 p0">
                        {this.state.loading
                            ? <Loader />
                            : (this.state.data ? (<Chart
                                chartType="PieChart"
                                 loader={<Loader />}
                                data={[['', '']].concat(this.state.data?.map((d) => { return [d.name, d.utilization_totalhr_count]; }))}
                                options={{
                                    legend: { position: 'labeled', labeledValueText: 'both' },
                                    pieSliceText: 'none',
                                    sliceVisibilityThreshold: 0,
                                    slices: this.state.data?.map((d) => { return { color: d.color_code } }),
                                    chartArea: { width: '90%', height: '90%' },
                                }}
                                rootProps={{ 'data-testid': '1' }} />) : null)
                        }
                    </div>
                    <div className="col-sm-12 text-muted fs11">
                        <sup>#</sup>{this.state.notes}<br/>
                        <sup>#2</sup>{this.state.notes2}<br/>
                        Report as of {this.state.remark_time}
                    </div>
                </div>
            </div>
            <UpdateMyDashboardForm
                ref={this.updateMyDashboardRef}
            />
        </div>);
    }
    
}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        iam_asset_types         :   state.app && state.app.asset_type ? state.app.asset_type : [],
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        widget_keys             :   state.app && state.app.user_info && state.app.user_info.widget_keys && state.app.user_info.widget_keys.length > 0 ? state.app.user_info.widget_keys : [],
    };
};

export default connect(mapStateToProps)(AssetWiseSegregation);
